import { ComponentType, forwardRef } from 'react';
import type { FontWeight } from '../../../styles/variables';
import { ParagraphType, TypographyTypes } from './Paragraph.data';
import { StyledParagraph } from './Paragraph.styles';

export { ParagraphType } from './Paragraph.data';

export interface ParagraphProps extends TypographyTypes {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  forwardedAs?: string | ComponentType<any>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  as?: string | ComponentType<any>;
  id?: string;
  type?: ParagraphType;
  fontWeight?: FontWeight;
}

export const Paragraph = forwardRef<HTMLParagraphElement, ParagraphProps>(
  (
    { forwardedAs, as = forwardedAs || 'p', type = ParagraphType.Normal, fontWeight, ...props },
    ref,
  ) => <StyledParagraph id="" ref={ref} as={as} $type={type} $fontWeight={fontWeight} {...props} />,
);

export const ParagraphId = forwardRef<HTMLParagraphElement, ParagraphProps>(
  (
    { forwardedAs, as = forwardedAs || 'p', type = ParagraphType.Normal, fontWeight, ...props },
    ref,
  ) => (
    <StyledParagraph
      id="navigation-flight-type"
      ref={ref}
      as={as}
      $type={type}
      $fontWeight={fontWeight}
      {...props}
    />
  ),
);
